import React, { useContext, useState } from "react";
import { AuthContext } from "../../hooks/AuthContext";
import { ChatContext } from "../../hooks/ChatContext";
import {
  arrayUnion,
  doc,
  serverTimestamp,
  Timestamp,
  getFirestore,
  updateDoc,
} from "firebase/firestore";
import {app, storage} from '../../firebaseConfig'
import { v4 as uuid } from "uuid";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import "./chatInput.scss"

const ChatInput = () => {

    const db = getFirestore(app);

    const [text, setText] = useState("");
    const [img, setImg] = useState<any>(null);

    const { currentUser } = useContext(AuthContext);
    const { data } = useContext(ChatContext);

    const handleSend = async () => {
        if (!data.chatId) {
            // Handle the case when chatId is null or undefined
            console.log("Chat ID is null or undefined");
            return;
        }

        if (img) {
        const storageRef = ref(storage, uuid());

        const uploadTask = uploadBytesResumable(storageRef, img);

        uploadTask.on('state_changed',
            (error) => {
            //TODO:Handle Error         
            },
            () => {
            getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
                await updateDoc(doc(db, "chats", data.chatId), {
                messages: arrayUnion({
                    id: uuid(),
                    text,
                    senderId: currentUser.uid,
                    date: Timestamp.now(),
                    img: downloadURL,
                }),
                });
            });
            }
        );
        } else {
        await updateDoc(doc(db, "chats", data.chatId), {
            messages: arrayUnion({
            id: uuid(),
            text,
            senderId: currentUser.uid,
            date: Timestamp.now(),
            }),
        });
        }

        await updateDoc(doc(db, "userChats", currentUser.uid), {
        [data.chatId + ".lastMessage"]: {
            text,
        },
        [data.chatId + ".date"]: serverTimestamp(),
        });

        await updateDoc(doc(db, "userChats", data.user.uid), {
        [data.chatId + ".lastMessage"]: {
            text,
        },
        [data.chatId + ".date"]: serverTimestamp(),
        });

        setText("");
        setImg(null);
    };

  return (
    <div className="input">
      <input
        type="text"
        placeholder="Type something..."
        onChange={(e) => setText(e.target.value)}
        value={text}
      />
      <div className="send">
        <img src="/assets/images/attach.png" alt="" />
        <input
          type="file"
          style={{ display: "none" }}
          id="file"
          onChange={(e:any) => setImg(e.target.files[0])}
        />
        <label htmlFor="file">
          <img src="/assets/images/img.png" alt="" />
        </label>
        <button onClick={handleSend}>Send</button>
      </div>
    </div>
  )
}

export default ChatInput